import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
// import LanguageDetector from 'i18next-browser-languagedetector'; // Detects user language

// Translation files
import translationEN from './locales/en/translation.json';
import translationAM from './locales/am/translation.json';
import translationFR from './locales/fr/translation.json';
// Language resources
const resources = {
    en: {
        translation: translationEN,
    },
    am: {
        translation: translationAM,
    },
    fr: {
        translation: translationFR,
    },
};

i18n
    // .use(LanguageDetector) // Automatically detect language
    .use(initReactI18next) // Passes i18n instance to react-i18next
    .init({
        resources,
        fallbackLng: 'en', // Fallback language
        interpolation: {
            escapeValue: false, // React already escapes values
        },
    });

export default i18n;


